<template>
    <div>
        <div class="EBSMonitor-title">
            <div>{{ $t('alarms.disk.disk') }}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['monitor:elasticBlockStoreMonitor:add_alert_rule']">{{ $t('alarms.disk.addDiskAlarm') }}</Button>
                <add-or-update-elastic-block-store-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-elastic-block-store-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" v-model="currentTab" :animated="false">
                <TabPane :label="$t('alarms.disk.diskList')" name="tabDisk">
                     <table-elastic-block-store @changeCurrentTab="changeCurrentTab"></table-elastic-block-store>
                </TabPane>
                <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
                  <div class="EBSMonitor-top">
                    <elastic-block-store-warning-alert-rule-search></elastic-block-store-warning-alert-rule-search>
                  </div>
                  <table-elastic-block-store-warning></table-elastic-block-store-warning>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import TableElasticBlockStore from '../ebs/TableElasticBlockStore'
    import AddOrUpdateElasticBlockStoreWarning from '../ebs/AddOrUpdateElasticBlockStoreWarning'
    import ElasticBlockStoreWarningAlertRuleSearch from "./ElasticBlockStoreWarningAlertRuleSearch";
    import TableElasticBlockStoreWarning from "./TableElasticBlockStoreWarning";
    const tableElasticBlockStoreWarning = TableElasticBlockStoreWarning
    export default {
        name: 'ElasticBlockStoreMonitor',
        components: {
            ElasticBlockStoreWarningAlertRuleSearch,
            TableElasticBlockStore,
            TableElasticBlockStoreWarning,
            AddOrUpdateElasticBlockStoreWarning
        },
        data(){
            return {
                currentTab:'',
                addOrUpdateVisible:false
            }
        },
        methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            },
            changeCurrentTab:function(row,monitorIndex){
              this.currentTab = 'tabAlertRule';
              eventBus.$emit('volumeId', row.volumeAwsId);
              eventBus.$emit('monitorIndex', monitorIndex);
              eventBus.$emit('typeId', 1);
              // eventBus.$emit('stateId', 0);
              tableElasticBlockStoreWarning.methods.showAll();
            }
        }
    }
</script>

<style scoped>
    .EBSMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .EBSMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .EBSMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/ebs/ElasticBlockStoreMonitor.vue